import React from 'react';

export const IconCameraRiscada = () => (
    <svg
        version='1.1'
        id='Layer_1'
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
        x='0px'
        y='0px'
        width='81px'
        height='79px'
        viewBox='0 0 81 79'
        enableBackground='new 0 0 81 79'
        xmlSpace='preserve'
    >
        <image
            id='image0'
            width='81'
            height='79'
            x='0'
            y='0'
            href='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFEAAABPCAMAAACkjdnvAAAABGdBTUEAALGPC/xhBQAAACBjSFJN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'
        />
    </svg>
);
